import { render, staticRenderFns } from "./AddNewUserModal.vue?vue&type=template&id=20937ea4&scoped=true"
import script from "./AddNewUserModal.vue?vue&type=script&lang=js"
export * from "./AddNewUserModal.vue?vue&type=script&lang=js"
import style0 from "./AddNewUserModal.vue?vue&type=style&index=0&id=20937ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20937ea4",
  null
  
)

export default component.exports